export default "__VITE_ASSET__DxdkZo4y__"